import React, { useState } from "react";
import { motion } from "framer-motion";
import { arrayOf, func, string, object } from "prop-types";

import CurrentLocationButton from "../CurrentLocationButton";
import MapFilterButton from "../MapFilterButton";
import MapFilter from "../MapFilter";
import { testDriveType } from "@types";

const MapSection = ({
  mapContainerRef,
  handleSetAddress,
  typeFilter,
  setTypeFilter,
  testDriveTypes,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  return (
    <div className="w-screen h-150 relative lg:w-full lg:h-[calc(100dvh-7.5rem)]">
      <div
        className="w-screen h-150 lg:w-full lg:h-[calc(100dvh-7.5rem)]"
        ref={mapContainerRef}
      />
      <div className="absolute bottom-4 right-2">
        <motion.div
          animate={{ y: isFilterOpen ? "-12rem" : 0 }}
          className="flex flex-col-reverse gap-2 lg:flex-row"
          initial={{ y: 0 }}
          isFilterOpen={isFilterOpen}
        >
          <MapFilterButton
            setIsFilterOpen={setIsFilterOpen}
            isFilterOpen={isFilterOpen}
          />
          <CurrentLocationButton
            setAddress={handleSetAddress}
            isFilterOpen={isFilterOpen}
          />
        </motion.div>
      </div>
      <MapFilter
        filter={typeFilter}
        isFilterOpen={isFilterOpen}
        setFilter={setTypeFilter}
        testDriveTypes={testDriveTypes}
      />
    </div>
  );
};

MapSection.propTypes = {
  handleSetAddress: func.isRequired,
  mapContainerRef: object.isRequired,
  setTypeFilter: func.isRequired,
  testDriveTypes: arrayOf(testDriveType),
  typeFilter: string,
};

export default MapSection;
